var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-logo",class:{
    selected: _vm.selected,
    loaded: _vm.loaded,
    error: _vm.error,
    vuejs: _vm.image && _vm.image.includes('vuejs')
  }},[_c('div',{staticClass:"wrapper"},[(_vm.selected)?_c('VueIcon',{attrs:{"icon":"done"}}):(_vm.displayImage)?_c('img',{key:_vm.imageUrl,staticClass:"image",attrs:{"src":_vm.imageUrl},on:{"load":function($event){_vm.loaded = true},"error":function($event){_vm.error = true}}}):_c('VueIcon',{attrs:{"icon":_vm.error || !_vm.image ? _vm.fallbackIcon : _vm.image}})],1),(_vm.displayImage && _vm.colorBullet)?_c('div',{staticClass:"color-bullet"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }